import { HelpPanel, Link } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { externalLinks } from '../../../../data/externalLinks';

export function GrantInfoHelpPanel() {
  const { t } = useTranslation(['translation']);
  return (
    <HelpPanel header={<h2>{t('grant.question')}</h2>}>
      <p>{t('grant.info.description')}</p>
      <Link
        href={externalLinks.volunteeringGrants}
        external
        data-aci-analytics-name="eventCreation_grantInfoLinkClicked"
        data-aci-analytics-value="Volunteering Grants Wiki"
      >
        {t('grant.info.linkText')}
      </Link>
    </HelpPanel>
  );
}
